<div *ngIf="loadError" class="report-only-error">{{ loadError }}</div>
<div *ngIf="!showSpinner && !loadError && reportConfig.id && reportConfig.embedUrl" style="margin-right: 18px;">
  <powerbi-report powerbi-type="report"
    [embedConfig]="reportConfig"
    style="height: 800px; width: 100%;"></powerbi-report>
</div>
<ngx-loading *ngIf="showSpinner" [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }"
  [template]="customLoadingTemplate">
</ngx-loading>
<ng-template #customLoadingTemplate>
  <div class="custom-class-loader">
    <div class="spinner-container">
      <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
    </div>
  </div>
</ng-template>
